var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import Modal from "../modal";
import Cropper from "../cropper";
import { ModalContent, ModalBody, ModalFooter } from "./styled/cropper-modal";
function CropperModal(_a) {
    var _b = _a.imageUrl, imageUrl = _b === void 0 ? "" : _b, footer = _a.footer, onClose = _a.onClose, props = __rest(_a, ["imageUrl", "footer", "onClose"]);
    var cropperRef = useRef();
    return (React.createElement(Modal, { onClose: onClose },
        React.createElement(ModalContent, null,
            React.createElement(Modal.Header, null,
                "Adjust Your Photo",
                React.createElement(Modal.Close, null)),
            React.createElement(ModalBody, null,
                React.createElement(Cropper, __assign({}, props, { src: imageUrl, onInitialized: function (cropper) {
                        cropperRef.current = cropper;
                    } }))),
            React.createElement(ModalFooter, null, footer({
                toBlob: function (handler) {
                    var _a, _b;
                    (_b = (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.getCroppedCanvas()) === null || _b === void 0 ? void 0 : _b.toBlob(handler, "image/png");
                },
                getData: function () { var _a; return (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.getData(); },
                getDataURL: function () { var _a, _b; return (_b = (_a = cropperRef.current) === null || _a === void 0 ? void 0 : _a.getCroppedCanvas()) === null || _b === void 0 ? void 0 : _b.toDataURL(); }
            })))));
}
export default CropperModal;
